import { Pipe, PipeTransform } from '@angular/core';
import { LoyaltyProgramReleaseThreshold } from '../models/entities/loyalty-program-release-threshold';
import { Porder } from '../models/entities/porder';


@Pipe({
  name: 'warehouse-transfer-pipe'
})

export class LoyaltyProgramReleaseThresholdPipe implements PipeTransform {
  
  constructor(){}



  transform(loyaltyProgramReleaseThreshold: LoyaltyProgramReleaseThreshold, field: string): any {
    let result = loyaltyProgramReleaseThreshold[field];

    if (field == 'partner') {
      let html = "<div class='label-red'>";
      if (result)  html += result.designation; else html += " -   -   -   -   -   - ";
      html += "</div>";
      return html;
    }

    if (field == 'kpi') {
      let html = "";
      if  (result)  {

        let color = 'gray';
        if (   (result.color == 'blue') 
        || (result.color == 'green') 
        || (result.color == 'orange') 
        || (result.color == 'darkOrange') 
        || (result.color == 'gray') 
        || (result.color == 'darkGray') 
        || (result.color == 'red') ) color = result.color;

        html = "<div class='label-" + color + "'>";
        html +=   result.name ;
        html += "</div>";
      }  
      return html;
    }

    return result;
  }
}
